import { StyleSheet } from 'aphrodite';
import { hexToRGBA } from '../../../../models/UiUtils';
import { brandPrimary, brandSecondary, gray4, midGray, white } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	circle: {
		padding: 0,
	},
	container: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		maxWidth: 860,
		width: '70vw',
	},
	imageContainer: {
		maxWidth: 500,
		position: 'relative',
		margin: '0 8px',
		...CssSelectors.allDescendants(
			{
				maxWidth: '100%',
			},
			'img'
		),
	},
	containerCenter: {
		display: 'flex',
		justifyContent: 'center',
	},
	infoWrapper: {
		width: '100%',
		border: `1px solid ${brandPrimary}`,
		background: hexToRGBA(brandPrimary, 0.05),
		padding: 8,
		borderRadius: 8,
		display: 'flex',
		alignItems: 'center',
		marginBottom: 16,
		marginTop: 16,
		gap: 8,
		boxSizing: 'border-box',
		...CssSelectors.allDescendants(
			{
				color: brandPrimary,
				fontSize: 14,
				margin: 0,
			},
			'p'
		),
		...CssSelectors.allDescendants(
			{
				margin: 0,
				padding: 0,
			},
			'figure'
		),
	},
	mainImage: {
		borderBottomRightRadius: 8,
		borderBottomLeftRadius: 8,
	},
	logoWrapper: {
		position: 'absolute',
		right: 0,
		bottom: 4,
		borderTopLeftRadius: 8,
		padding: '4px 16px',
		boxSize: 'border-box',
		background: white,
		...CssSelectors.allDescendants(
			{
				maxWidth: 200,
			},
			'img'
		),
	},
	logoWrapperHideBackground: {
		background: 'transparent',
	},
	pointLeft: {
		height: 15,
		transform: 'rotateZ(90deg)',
		width: 20,
	},
	pointRight: {
		height: 15,
		transform: 'rotateZ(270deg)',
		width: 20,
	},
	tabNavigation: {
		alignItems: 'center',
		display: 'flex',
		gap: 6,
		justifyContent: 'center',
		paddingBottom: 6,
		paddingTop: 6,
	},
	logoSizeControls: {
		width: '100%',
		padding: '16px 0',
		marginTop: 16,
		borderTop: `1px solid ${midGray}`,
	},
	sliderHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: 12,
		fontSize: 14,
		fontWeight: 600,
		color: gray4,
	},
	sizeValue: {
		color: brandSecondary,
		fontWeight: 700,
	},
	slider: {
		width: '100%',
		height: 6,
		borderRadius: 3,
		background: midGray,
		outline: 'none',
		WebkitAppearance: 'none',
		appearance: 'none',
		'::-webkit-slider-thumb': {
			WebkitAppearance: 'none',
			appearance: 'none',
			width: 18,
			height: 18,
			borderRadius: '50%',
			background: brandSecondary,
			cursor: 'pointer',
			border: `2px solid ${white}`,
			boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
		},
		'::-moz-range-thumb': {
			width: 18,
			height: 18,
			borderRadius: '50%',
			background: brandSecondary,
			cursor: 'pointer',
			border: `2px solid ${white}`,
			boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
		},
	},
	controlButtons: {
		display: 'flex',
		gap: 8,
		marginTop: 12,
		justifyContent: 'flex-end',
	},
});
